import {
    fetchTheTweet,
} from "../../services/tweetService";

import cogoToast from 'cogo-toast';
import { FETCHING_TWEET_FAIL, FETCHING_TWEET_STARTED, FETCHING_TWEET_SUCCESS } from "./tweetSlice";


export const fetchTweet = (tweetid, callback) => async (dispatch) => {
    try {
        if (!tweetid) throw new Error('No tweet id provided')
        dispatch(FETCHING_TWEET_STARTED())
        const data = await fetchTheTweet(tweetid);
        dispatch(FETCHING_TWEET_SUCCESS(data))
        callback(data);
    } catch (error) {
        console.log(error);
        cogoToast.error(error.message)
        dispatch(FETCHING_TWEET_FAIL(error.message))
    }
}